$(() => {
    // pagination active bullet
    let btnDec = $(".pagination .prev");
    let btnInc = $(".pagination .next");
    let bullets = $(".pagination ul li");

    // $(document).on('click', btnDec, decrementBullet);
    // $(document).on('click', btnInc, incrementBullet);

    function decrementBullet() {
        let current = $(".pagination ul li.active");
        let prev = current.prev("li");

        if ( prev.length ) {
            current.removeClass("active");
            prev.addClass("active");
        }

        // disable if page 1 is active
        btnDec.prop("disabled", bullets.first().hasClass("active"));
        btnInc.prop("disabled", false);
    }

    function incrementBullet() {
        let current = $(".pagination ul li.active");
        let next = current.next("li");

        if ( next.length ) {
            current.removeClass("active");
            next.addClass("active");
        }

        // disable if last page is active
        btnInc.prop("disabled", bullets.last().hasClass("active"));
        btnDec.prop("disabled", false);
    }

    btnDec.prop("disabled", bullets.first().hasClass("active"));
    btnInc.prop("disabled", bullets.last().hasClass("active"));

    //paginacao ajax
    $(document).on('click', "#load-next", function() {
        incrementBullet();
        let page = $("[data-paginate].active").attr('data-paginate');
        loadMore(page);
    });
    $(document).on('click', "#load-previous", function() {
        decrementBullet();
        let page = $("[data-paginate].active").attr('data-paginate');
        loadMore(page);
    });
    $("[categoryId]").on('click', function() {
        let page = '?page=1';
        if ($(this).attr('active')) {
            $(this).removeAttr('active');
            $(this).removeClass('active');
        } else {
            $("[categoryId]").removeAttr('active')
            $(this).attr('active', '1');
        }
        loadMore(page);
    });

    function loadMore(pageUrl) {
        if ($("[categoryId][active=1]").get() && typeof($("[categoryId][active=1]").attr('categoryId')) != 'undefined') {
            pageUrl = pageUrl + '&category=' + $("[categoryId][active=1]").attr('categoryId');
        }
        $.ajax({
            url: pageUrl,
            type: 'get',
            datatype: 'html',
            success: function(data) {
                $('#posts').html(data);
            }
        })
        .done(function() {
            let btnDec = $(".pagination .prev");
            let btnInc = $(".pagination .next");
            let bullets = $(".pagination ul li");
            btnDec.prop("disabled", bullets.first().hasClass("active"));
            btnInc.prop("disabled", bullets.last().hasClass("active"));
        })
        .fail(function(jqXHR, ajaxOptions, thrownError) {
            alert('Algo deu errado.');
        });
    }


    //animaiton of the page

    // Select all divs inside #home
    const divs = document.querySelectorAll("#posts .row > div");

    // Loop through each div and apply animations
    divs.forEach((div, index) => {
        gsap.timeline({
            scrollTrigger: {
                trigger: div, // Trigger animation when this div is in view
                start: "top 80%", // Start animation when the top of the div is 80% into the viewport
                end: "top 20%", // End animation when the top of the div is 20% into the viewport
                toggleActions: "play none none none", // Play the animation once
            },
            defaults: {
                duration: 1.8,
                ease: "power4.out", // Smooth easing
            },
        })
        .fromTo(div,
            {
                clipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)", // Clipped
                opacity: 0, // Hidden
                scale: 0.95, // Slightly smaller
                y: 100, // Positioned below
                filter: "blur(10px)", // Start blurry
            },
            {
                clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)", // Fully revealed
                opacity: 1, // Fully visible
                scale: 1, // Normal size
                y: 0, // Original position
                filter: "blur(0px)", // Clear
            }
        )
    });


})
